import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { IoRemoveOutline } from "react-icons/io5";

const ServiceAccoudion = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full">
      <div className="rounded-lg divide-y divide-gray-300 shadow-sm">
        {faqs.map((faq, index) => (
          <div data-aos="fade-up" data-aos-duration="700" key={index} className="overflow-hidden">
            <button
              onClick={() => toggleAccordion(index)}
              className={`w-full flex gap-5 justify-between familjen-font items-center py-4 text-left transition-all duration-500 ${openIndex === index
                  ? "text-[#0BB6D9] font-semibold"
                  : "text-gray-800"
                }`}
            >
              <span className="font-bold text-xl">{faq?.question}</span>
              <span
                className={`text-2xl font-light transition-transform duration-300 ${openIndex === index ? "text-[#0BB6D9]" : "rotate-0"
                  }`}
              >
                {openIndex === index ? <IoRemoveOutline /> : <FiPlus />}
              </span>
            </button>

            <div
              className={`transition-all duration-500 ease-in-out ${openIndex === index
                  ? "max-h-40 opacity-100 py-2"
                  : "max-h-0 opacity-0 py-0"
                }`}
            >
              <p className="text-[#4f4f4f] text-sm leading-relaxed">
                {faq?.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceAccoudion;
